import { FC, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import useGetLikes from '../../../hooks/useGetLikes'

import { ILike } from '../../../constants/types/common.types'

interface ILikeGet {
  id: string
}

const LikeGet: FC<ILikeGet> = ({ id }: ILikeGet) => {
  const [likes, setLikes] = useState<ILike>({
    likeCount: '',
    like: false,
  })

  useGetLikes(id, setLikes, true)

  return <>{likes.likeCount || <Skeleton width={50} />}</>
}

export default LikeGet
